/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions } from './FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions,
    FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSON,
    FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions';

/**
 * @type FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId = FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions;

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON(json: any): FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(json)) {
        return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSONTyped(value?: FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(value)) {
        return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON(value as FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions);
    }

    return {};
}

